

export const ucpNav = [{
      title: 'Dashboard',
      fafa: 'fa fa-fw fa-dashboard',
      id: 'think_dashboard',
      childId: 'think_dashboardChildID',
      childIdHash: '#think_dashboardChildID',
      routerLink: ['think/think_dashboard'],
      disabled: false,
      visible: true,
}, {
      title: 'Global Search',
      fafa: 'fa fa-search',
      id: 'headingGlobalSearch',
      childId: 'globalSearchSubMenu',
      childIdHash: '#globalSearchSubMenu',
      disabled: false,
      visible: true,
      children: [{
            title: 'Customer',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/customer_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Product',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/product_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Agency',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/agency_search'],
            disabled: false,
            visible: true,
      }]
}, {
      title: 'Extract',
      fafa: 'fa fa-file-text-o',
      id: 'headingExtract',
      childId: 'ExtractSubMenu2',
      childIdHash: '#ExtractSubMenu2',
      disabled: false,
      visible: true,
      children: [{
            title: 'DECIR With Finance',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/decir_with_finance'],
            disabled: true,
            visible: false,
      }, {
            title: 'DCIER With Doc Ref',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/dcier_with_doc_ref'],
            disabled: false,
            visible: false,
      }, {
            title: 'Detail Circulation Report',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/detail_circulation_report'],
            disabled: false,
            visible: true,
      },
      {
            title: 'Details Circulation for Pack',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/detail_circulation_for_pack'],
            disabled: false,
            visible: true,
      },
      {
            title: 'Detail Circ. excld Pack',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/detail_circ_excld_report'],
            disabled: false,
            visible: true,
      },
      {
            title: 'Detail Circulation For UCP Pack',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/detail_circ_ucp_pack'],
            disabled: false,
            visible: true,
      },
      {
            title: 'Agency Details',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/agency_details'],
            disabled: false,
            visible: true
      },
      {
            title: 'Single Issue Orders',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/single_issue_orders'],
            disabled: false,
            visible: true,
      }, {
            title: 'Customer Details',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/customer_details'],
            disabled: false,
            visible: true,
      }, {
            title: 'Gratis Orders',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/gratis_orders'],
            disabled: false,
            visible: true,
      }, {
            title: 'Gift Orders',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/gift_orders'],
            disabled: false,
            visible: true,
      }]
},
{
      title: 'Sales',
      fafa: 'fa fa-pie-chart',
      id: 'headingSalesSubMenu',
      childId: 'salesSubMenu2',
      childIdHash: '#salesSubMenu2',
      disabled: false,
      visible: true,
      children: [{
            title: 'Sales Report',
            fafa: 'fa fa-angle-right',
            disabled: false,
            visible: true,
            childId: 'salesReportSubMenu',
            childIdHash: '#salesReportSubMenu',
            children: [{
                  title: 'Detailed Sales Summary Search ',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['think/sales_summary_search'],
                  disabled: false,
                  visible: true,
            }, {
                  title: 'Sales By Category',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['think/sales_by_category_search'],
                  disabled: true,
                  visible: false,
            }, {
                  title: 'Direct Customer Sales',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['think/direct_customer_sales'],
                  disabled: false,
                  visible: true,
            }, {
                  title: 'Sales By Agency Details',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['think/sales_by_agency'],
                  disabled: false,
                  visible: true,
            }, {
                  title: 'Sales By Month',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['think/sales_by_month'],
                  disabled: false,
                  visible: true,
            }, {
                  title: 'Sales By Region',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['think/sales_by_region'],
                  disabled: false,
                  visible: true,
            }]

      }, {
            title: 'Top N Customers',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/top_n_customers'],
            disabled: true,
            visible: false,
      }, {
            title: 'Top N Products',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/top_n_products'],
            disabled: true,
            visible: false,
      }, {
            title: 'Comparison',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/comparision'],
            disabled: true,
            visible: false,
      }, {
            title: 'Agencies Customer Sales',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/agencies_customer_sales'],
            disabled: true,
            visible: false,
      }, {
            title: 'Future Expires',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/future_expires'],
            disabled: false,
            visible: true,
      }, {
            title: 'Future Expires With New Order',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/future_expires_with_new_order'],
            disabled: false,
            visible: true,
      }, {
            title: 'Orders By Source Code',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/order_by_source_code'],
            disabled: false,
            visible: true,
      }]
}, {
      title: 'YTD Reports',
      fafa: 'fa fa-file',
      id: 'headingSalesSubMenu',
      childId: 'ytdSubMenu2',
      childIdHash: '#ytdSubMenu2',
      disabled: false,
      visible: true,
      children: [{
            title: 'YTD Amount by Start Year',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/ytd_amount_by_start_year'],
            disabled: false,
            visible: true,
      }, {
            title: 'YTD Orders by Start Year',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/ytd_orders_by_start_year'],
            disabled: false,
            visible: true,
      }, {
            title: 'YTD Orders by Customer',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/ytd_orders_by_customer'],
            disabled: false,
            visible: true,
      }]
}, {
      title: 'Accounting',
      fafa: 'fa fa-calculator',
      id: 'headingAccountingSubMenu',
      childId: 'accountingSubMenu2',
      childIdHash: '#accountingSubMenu2',
      disabled: false,
      visible: true,
      children: [{
            title: 'Customer Deposits',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/customer_deposit_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Tax Liability',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/taxliability_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Earned & Deferred Income',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/earned_deferred_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Deferred Liability Summary',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/deferred_liability_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Cash By A/C Period',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/cash_acc_period_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Payment By Currency',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/payment_by_currency'],
            disabled: false,
            visible: false,
      }, {
            title: 'Refunds',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/refund_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Monthly Deferred Revenue',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/monthly_deferred_revenue'],
            disabled: false,
            visible: false,
      }, {
            title: 'New Orders Reconciliation',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/new_orders_reconciliation_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Cancel Orders Reconciliation',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/cancel_orders_reconciliation_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Aged AR Customerwise',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/aged_ar_customerwise_search'],
            disabled: false,
            visible: false,
      }, {
            title: 'Future Earning',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/future_earning'],
            disabled: false,
            visible: false,
      }, {
            title: 'VAT Exempt Details',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/vatExempt'],
            disabled: false,
            visible: false,
      }, {
            title: 'VAT ESL Report',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/vatESL'],
            disabled: true,
            visible: false,
      }, {
            title: 'EC Sales',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/ecSales'],
            disabled: true,
            visible: false,
      }, {
            title: 'Intrastat Report',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/intrastat'],
            disabled: true,
            visible: false,
      }]
}, {
      title: 'Fulfillment',
      fafa: 'fa fa-edit',
      id: 'headingFulfillmentSubMenu',
      childId: 'fulfillmentSubMenu2',
      childIdHash: '#fulfillmentSubMenu2',
      disabled: false,
      visible: true,
      children: [{
            title: 'Issue List',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/issue_list'],
            disabled: true,
            visible: false,
      }, {
            title: 'Inventory Stock List',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/inventory_stock_list'],
            disabled: true,
            visible: false,
      }, {
            title: 'Active Source Code',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/active_source_code'],
            disabled: false,
            visible: true,
      }, {
            title: 'Grace Copy Setup',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/grace_copy_setup'],
            disabled: true,
            visible: false,
      }, {
            title: 'Customer Order Details',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/customer_order_details'],
            disabled: true,
            visible: false,
      }, {
            title: 'Lapser Report',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/lapser_report'],
            disabled: false,
            visible: true,
      }, {
            title: 'Cancelled Orders',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/cancelled_orders'],
            disabled: false,
            visible: true,
      }, {
            title: 'Price Setup',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/price_setup'],
            disabled: true,
            visible: false,
      }, {
            title: 'Renewals Count By Month',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/renewals_count_month'],
            disabled: true,
            visible: false,
      }, {
            title: 'Lapser & Renewal Effort',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/lapser_renewal_effort'],
            disabled: true,
            visible: false,
      }]
}, {
      title: 'Credit Sales',
      fafa: 'fa fa-credit-card',
      id: 'headingCreditSalesSubMenu',
      childId: 'creditSalesSubMenu2',
      childIdHash: '#creditSalesSubMenu2',
      disabled: false,
      visible: false,
      children: [{
            title: 'Invoices By Terms',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/invoices_by_terms_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Stop Orders',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/stop_orders_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Overdue Payment',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/overdue_payment_search'],
            disabled: false,
            visible: true,
      }, {
            title: 'Credit Payment Collection',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/credit_payment_collection'],
            disabled: false,
            visible: true,
      }, {
            title: 'Generated Sales Invoices',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/generated_sales_invoices'],
            disabled: false,
            visible: true,
      }, {
            title: 'Generated Credit Notes',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/generated_credit_notes'],
            disabled: false,
            visible: true,
      }, {
            title: 'Bad Debtors Notes',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/bad_debtors'],
            disabled: false,
            visible: true,
      }, {
            title: 'Duplicate Invoice',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/duplicate_invoice'],
            disabled: false,
            visible: true,
      }, {
            title: 'Duplicate Credit Note',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/duplicate_credit_note'],
            disabled: false,
            visible: true,
      }, {
            title: 'DECIR with Cancel Orders',
            fafa: 'fa fa-angle-right',
            routerLink: ['think/decir_with_cancel_orders'],
            disabled: false,
            visible: true,
      }]
}];



// WEBPACK FOOTER //
// ./src/app/pages/left-nav/nav.ucp.ts